import { Grid } from "@mui/material";
import { IFileResponse } from "../../../../models/loan.model";
import { IMultiImage } from "./IMultiImage";
import { useEffect, useState } from "react";
import AttachmentFileModal from "../../../../components/modal/attachmentFileModal/attachmentFileModal";
import { useDispatch } from "react-redux";
import { changeRouteType, getNextInnerState, getpervInnerState } from "../../../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../../../redux/headerTitle/headerTitleSlice";

export default function FullScreenMultiImage({ data }: any) {
    const [openModal, setOpenModal] = useState(false)
    const [selectedFileURL, setSelectedFileURL] = useState<string>()
    const [selectedTitle, setSelectedTitle] = useState<string>()

    const dispatch = useDispatch();



    useEffect(() => {

        dispatch(
            setHeaderTitle({
                color: "var(--header-color)",
                header: 'جزییات تصاویر ضمیمه شده',
                parentRoute: 'loanDetailAttachedFile',
            })
        );
        //dispatch(getpervInnerState({ prevInnerState: `loanDetailAttachedFile`}));
        dispatch(getNextInnerState({ nextInnerState: 'loanDetailFullScreenMultiImage' }));

        // dispatch(getpervInnerState({ prevInnerState: `loanDetailAttachedFile` }));

    }, [])

    const handleClick = (index: number) => {
        setSelectedFileURL(data[index]?.fileUrl);
        setSelectedTitle(data[index]?.documentTypeTitle);
        setOpenModal(true)
    }

    return (
        <>
            <div className="p-5" style={{ marginTop: "20px" }} >
                <Grid container xs={12} >
                    {data.map((item: any, index: any) => {
                        return <>
                            <Grid item xs={4} spacing={1} style={{ paddingBottom: "5px", paddingLeft: "5px" }} onClick={() => handleClick(index)}>

                                <img
                                    src={data[index]?.fileUrl}
                                    className="text-center block m-auto"
                                    style={{ width: "100%", height: "80px" }}
                                />

                            </Grid>
                        </>
                    })}
                    <AttachmentFileModal openModal={openModal} file={selectedFileURL} fileName={selectedTitle} setOpenModal={setOpenModal}></AttachmentFileModal>


                </Grid >
            </div>
        </>
    )
}